module.exports = __webpack_public_path__ + "img/6_127.29a1fc96.png";